
import React, { useEffect, useState } from "react";
import { Button, Menu, MenuProps, Modal, theme } from "antd";
import styled from "styled-components";
import { useLocation, useNavigate } from "react-router-dom";
import ModalComponent from "../Modal";

function MenuComponent() {
  const StyledMenu = styled(Menu)`
  &.ant-menu-horizontal {
    border: none !important; // 去掉底部边框
    height: 40%;
  }
    

  .ant-menu-item::after,
 .ant-menu-submenu::after {
    border-bottom: none !important; /* 去掉底部的蓝色下边框 */
  }

  .ant-menu-item,
  .ant-menu-submenu-title {
    color: black !important; // 未选中样式
    font-weight: bold;
    &:hover {
      background-color: transparent !important; // 划过样式
      color: #aae260  !important;
      border-bottom: none !important; /* 去掉底部的蓝色下边框 */
    }
  }

  .ant-menu-item-selected {
    background-color: transparent !important; // 选中样式
    border-bottom: none !important; // 强制去掉默认的选中下划线
    color: #aae260  !important;
    &:hover {
      background-color: transparent !important; // 选中且划过样式
    }
  }

  .ant-menu-submenu-selected::after {
    border-bottom: none !important; /* 去掉选中时的蓝色下边框 */
  }

  .ant-menu-submenu-selected {
    background-color: transparent !important; // 选中样式
    border-bottom: none !important; // 强制去掉默认的选中下划线
    color: #aae260  !important;
    .ant-menu-submenu-title {
      color: #aae260  !important;
    }
  }
`;
const location=useLocation()
const navigate=useNavigate()
const [RoleValue, setRoleValue] = useState(sessionStorage.getItem("role"));
useEffect(()=>{
  setRoleValue(sessionStorage.getItem("role"))
},[sessionStorage.getItem("role")])
 const [IsOpemModal, setIsMoenModal] = useState(false);
      const showModal = () => {
        setIsMoenModal(true);
      };
      const handleOk = () => {
        setIsMoenModal(false);
      };
      const handleCancel = () => {
        setIsMoenModal(false);
      };
  const TopItems = [
    {
      label: (
        <a href="#/Breeding/home/" style={{fontSize:"19px", fontWeight: "bold" }}>
          Home
        </a>
      ),
      key: "1",
    },
{
  key:"2",
  label:(
    <a href="#/Breeding/MFMGP/" style={{fontSize:"19px", fontWeight: "bold" }}>
      MFMGP
    </a>
  ),
},
{
  key:"7",
  label:<a href="https://pfmgp.bioaibp.com/#/Breeding/PFMGP/"  style={{fontSize:"19px", fontWeight: "bold" }}>PFMGP</a>
},
    {
      label:(
        RoleValue=='A'?
        <p  onClick={showModal}  style={{fontSize:"19px", fontWeight: "bold" }}>
          Pheno
        </p>: <p  onClick={showModal} style={{fontSize:"19px", fontWeight: "bold" }}>Database</p>),
        key:"3"
    },
    {
      label: (
         <a  onClick={showModal}  style={{fontSize:"19px", fontWeight: "bold" }}>
          AIGS
        </a>
      ),
      key: "4",
    },
    {
      label: (
        <a  onClick={showModal} style={{fontSize:"19px", fontWeight: "bold" }}>
          Breeding
        </a>
      ),
      key: "5",
    },
    {
      label: (
        <a  onClick={showModal} style={{fontSize:"19px", fontWeight: "bold" }}>
          Help
        </a>
      ),
      key: "6",
    },
  ];
  const [current, setCurrent] = useState(
    sessionStorage.getItem("breedKey")
     || "1"
  );
  useEffect(()=>{
    setCurrent(sessionStorage.getItem("breedKey"))
  },[sessionStorage.getItem("breedKey")])


  useEffect(() => {
    // 根据当前路径设置当前选中的菜单项
    const pathToKey = {
      "/Breeding/home/": "1",
      "/Breeding/introduction/": "3",
      "/Breeding/modelinter/": "4",
      "/Breeding/breedident/": "5",
      "/Breeding/help/": "6",
    };

    const currentKey = pathToKey[location.pathname];
    if (currentKey=="1" || currentKey=="2") {
      setCurrent(currentKey);
      sessionStorage.setItem("breedKey", currentKey);
    }
  }, [location.pathname]);
  const onClick = (e) => {
 if (e.key === "1" || e.key === "2") {
    setCurrent(e.key);
    sessionStorage.setItem("breedKey", e.key);
  }
    sessionStorage.setItem('BreedMenuKey','left1')
    sessionStorage.setItem('ModelMenuKey','left1')
    sessionStorage.setItem('PhenoMenuKey','left1')
  };

  return (
    <>
<Modal
        open={IsOpemModal}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={
          <div>
            <Button
              onClick={handleCancel}
              style={{
                background: "transparent",
                border: "1px solid #46766a",
                fontSize: "14px",
                color: "#46766a",
                marginRight: "10px",
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleOk}
              style={{
                background: "#46766a",
                color: "white",
                border: "1px solid #46766a",
                fontSize: "14px",
              }}
            >
              ok
            </Button>
          </div>
        }
      >
        <div
          className="contact_app"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={require("../../assets/img/Homev2/Official_account.png")}
            style={{
              width: "80%",
            }}
            alt=""
          />
          <p
            style={{
              fontSize: "18px",
            }}
          >
            扫码关注公众号 回复"MFMGP"
          </p>
          <p style={{
          fontSize:"16px",
        }}>进入技术交流群</p>
        </div>
      </Modal>
     <StyledMenu
        style={{width:"100%",  height: "50px",display:"flex",alignItems:"center" ,background:"transparent" }}
        onClick={onClick}
        selectedKeys={[current]}
        mode="horizontal"
        items={TopItems}
      />
    </>
     
  );
}

export default MenuComponent;
